import { ref } from "vue";

/** Bumped when project list activity changes so the sidebar re-sorts / refreshes times. */
export const projectSidebarListRevision = ref(0);

export function bumpProjectSidebarListRevision(): void {
  projectSidebarListRevision.value += 1;
}
